import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs, Autoplay, Keyboard, Controller, EffectFade} from 'swiper/modules';
Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Keyboard, Controller, EffectFade]);
window.Swiper = Swiper;
